"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const constants_1 = __importDefault(require("@/constants"));
const profile_card_1 = __importDefault(require("../profile-card"));
const profile_journeys_1 = __importDefault(require("../profile-journeys"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Profile = ({ user, journeys, className, }) => ((0, core_1.jsx)("div", { className: (0, carabiners_1.joinStr)(styles_scss_1.default.container, className) },
    (0, core_1.jsx)("h1", null, constants_1.default.profile.title),
    (0, core_1.jsx)("hr", { className: styles_scss_1.default.ruler }),
    (0, core_1.jsx)(profile_card_1.default, { user: user }),
    (0, core_1.jsx)("hr", { className: styles_scss_1.default.ruler }),
    (0, core_1.jsx)(profile_journeys_1.default, { journeys: journeys })));
Profile.defaultProps = {
    className: undefined
};
exports.default = Profile;
